module.exports = "/_next/static/images/c9cc48b39dc76e20856fa0745bb4fab5-icon-monthly-payments-new.svg.webp";